import { Image, SidebarModal } from '@domain-group/suit-theme'

import NewImageUrl from './assets/new-campaign.svg'
import ExistingImageUrl from './assets/existing-campaign.svg'

interface DefaultStateProps {
  callbacks: {
    selectScreen: (string: 'NewCampaign' | 'ExistingCampaign') => void,
  },
  hideComponents?: Array<'ExistingCampaign' | 'NewCampaign'>,
}

const DefaultState = (props: DefaultStateProps) => {
  const {
    callbacks: { selectScreen },
    hideComponents = [],
  } = props

  return (
    <SidebarModal.Content hasFooter={false}>
      {!hideComponents.includes('NewCampaign') && (
        <SidebarModal.Button
          iconLeft={<Image height={40} width={40} url={NewImageUrl} />}
          onClick={() => selectScreen('NewCampaign')}
          showAngleIcon
          subtitle="Add order to a new campaign"
          title="Create New"
        />
      )}

      {!hideComponents.includes('ExistingCampaign') && (
        <SidebarModal.Button
          iconLeft={<Image height={40} width={40} url={ExistingImageUrl} />}
          onClick={() => selectScreen('ExistingCampaign')}
          showAngleIcon
          subtitle="Add order to an existing campaign"
          title="Add to Existing"
        />
      )}
    </SidebarModal.Content>
  )
}

export default DefaultState
